import { Controller } from "stimulus"

export default class extends Controller {
  confirm(event) {
    const message = this.element.dataset.confirmMessageValue
    if (!message) return
    if (window.confirm(message)) return

    event.preventDefault()
  }
}
